import React, { Component } from 'react';
import {Footer, SideNav, TopBar} from '../partials/layouts.js';
import { LogoutModal } from './logout.js';
const XLSX = require('xlsx');
const moment = require('moment');

/*
function PrintResidentStatus(props) {
    const resident_status_list = props.data.map((item, index)=>
      <li key={item.id} className="list-group-item py-0 px-0">
        <div className="row no-gutters">
          <div className="col-1">{index+1}</div>
          <div className="col-3">{item.name}</div>
          <div className="col-2">{item.city?item.city:""}</div>
          <div className="col-2 ">{item.fee_name}</div>
          <div className="col-2 ">{item.status}</div>
          <div className="col-2 ">{item.fee_expires_in} days</div>
        </div>
      </li>
    );
    return(
      <>
          <div className="d-print-block">
            <div className="row no-gutters border-bottom border-dark">
              <div className="col-1">S.No</div>
              <div className="col-3">Resident Name</div>
              <div className="col-2">City</div>
              <div className="col-2">Residentship Fee</div>
              <div className="col-2">Status</div>
              <div className="col-2">Will Expire in</div>
            </div>
            <ul className="list-group list-group-flush">
              {resident_status_list}
            </ul>
          </div>
      </>
    );
}
*/
class ResidentStatusList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      residents_report :[],
      fees          :[],
      q_param        :"",
      isLoading      :true,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleOnExport = this.handleOnExport.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value =  target.value;
    this.setState({
      q_param: value
    });
    this.getResidentStatus(value);
  }

  handleOnExport() {
    var elt = document.getElementById('dataTable');
  	var wb = XLSX.utils.table_to_book(elt, {sheet:"residents_report"});
  	var fileName = `Resident_Status_List_${moment().format('DD-MM-YYYY')}.xlsx`;
  	XLSX.writeFile(wb, fileName);
  }

  async getResidentStatus(params) {
    try {
      const response = await fetch('/api/resident-status?fee_id='+params);
      const json = await response.json();
      console.log(json);
      this.setState({ residents_report: json.residents, fees:json.fees });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getResidentStatus(this.state.q_param);
  }
  render(){
    if(!this.state.isLoading){
      const resident_status = this.state.residents_report;
      const fees = this.state.fees;
      const resident_status_list = resident_status.map((m)=>
          <tr key={m.id+m.fee_name} id={m.id}>
              <td>{m.first_name} {m.last_name}</td>
              <td>{m.wo_street_address}</td>
              <td>{m.fee_name}</td>
              <td>{m.is_paid?"Paid":"Pending"}</td>
          </tr>
      );
      const fee_options = fees.map((p)=>
        <option key={p.id} value={p.id}>{p.name}</option>
      );

      return(
        <>
        <div className="d-flex justify-content-start mb-2 d-print-none">
            <select name="fee_id" className="form-select" value={this.state.q_param} onChange={this.handleInputChange} style={{width:'40%'}}>
                <option value="">All Fees</option>
                {fee_options}
            </select>
            <button className="btn btn-primary mx-2" onClick={()=>window.print()}>Print</button>
            <button className="btn btn-success" onClick={this.handleOnExport}>XLSX</button>
        </div>
        <div className="row">
            <div className="col-12">
                <div className="card shadow mb-4">
                    <div className="card-header py-3 d-print-none">
                        <h4 className="m-0 font-weight-bold text-light">Property Owner Status</h4>
                    </div>
                    <h4 className="d-none d-print-block pl-3 pt-3">Property Owner Status Report on {moment().format('LL')} </h4>
                    <div className="card-body">
                        <div className="table-responsive d-print-block resident-table">
                            <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Address</th>
                                        <th>HOA Fee</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                  {resident_status_list}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
      );
    }
  }
}

function ResidentStatusReport() {
  return (
    <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                        <ResidentStatusList />
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
    </>
  );
}

export { ResidentStatusReport };
